import { Link } from "react-router-dom";

import { Icon } from "~/assets/icons/Icon";
import Button from "~/components/mantine/button/Button";
import { useAuth } from "~/contexts/AuthProvider";
import { routes } from "~/router";

import LaunchChecklist from "../checklist/LaunchChecklist";
import styles from "./AutoptoWelcome.module.scss";
import WelcomeVideo from "./WelcomeVideo";

type Props = {
  canCreateSite: boolean;
};

/**
 * The dashboard of an Autopto agency without sites yet: the welcome tour
 * and the way to add a client's
 * website and the launch checklist.
 */
const AutoptoWelcome = ({ canCreateSite }: Props) => {
  const { user } = useAuth();

  const greeting = user?.first_name
    ? `Welcome to Your New Platform, ${user.first_name}`
    : "Welcome to Your New Platform";

  return (
    <div className={styles.welcome}>
      <header className={styles.header}>
        <h2 className={styles.greeting}>{greeting}</h2>
        <p className={styles.subtitle}>
          Watch the quick tour, then add a client's website to see exactly what
          they'll see when they log in.
        </p>
      </header>
      <WelcomeVideo />
      {canCreateSite && (
        <div className={styles.addSite}>
          <Button
            // Kyle: the main step of this view, bigger than a regular button.
            size="lg"
            component={Link}
            to={routes.site.wizard({ tab: "new" })}
            onClick={() => localStorage.removeItem("siteId")}
          >
            <Icon iconName="PlusIcon" /> Add a Website
          </Button>
          <span className={styles.addSiteHint}>
            See how clients will experience your platform
          </span>
        </div>
      )}
      <LaunchChecklist hasSites={false} canCreateSite={canCreateSite} />
    </div>
  );
};

export default AutoptoWelcome;
